import { render, staticRenderFns } from "./integralRecord.vue?vue&type=template&id=89ef62d4&scoped=true&"
import script from "./integralRecord.vue?vue&type=script&lang=js&"
export * from "./integralRecord.vue?vue&type=script&lang=js&"
import style0 from "./integralRecord.vue?vue&type=style&index=0&id=89ef62d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ef62d4",
  null
  
)

export default component.exports